import { GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { signInWithPopup } from "firebase/auth";
import { useAppDispatch, useAppSelector } from "@packages/store/hooks";
import { loginUser } from "@packages/store/userSlice";
import logo from "@packages/assets/swann-icon.png";
import bilfen from "@packages/assets/bilfen.jpg";
import isik from "@packages/assets/isik.png";
import itugv from "@packages/assets/itugv.png";
import ayseabla from "@packages/assets/ayseabla.png";
import sev from "@packages/assets/sev.png";
import tedAnkara from "@packages/assets/ted_ankara.svg";
import ted from "@packages/assets/ted.png";
import msu from "@packages/assets/msu.png";
import nun from "@packages/assets/nun.png";
import mba from "@packages/assets/mba.png";
import yetev from "@packages/assets/yetev.svg";
import mef from "@packages/assets/mef.png";
import ielev from "@packages/assets/ielev.jpg";
import cihangir from "@packages/assets/cihangir.png";
import mecOkullari from "@packages/assets/mecokullari.png";
import hisar from "@packages/assets/hisar.png";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button, Text, Input } from "@core/index";
import { AnimatePresence, motion } from "framer-motion";
import { useMobile } from "@packages/hooks/useMobile";

// Add these icon imports for the features
const BrainIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L7 12.5l2.091 2.091a2.25 2.25 0 01.659 1.591v5.714M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

const BookOpenIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25A8.966 8.966 0 0118 3.75c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0118 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
    />
  </svg>
);

const UsersIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
    />
  </svg>
);

const SparklesIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
    />
  </svg>
);

const LoginView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector((state) => state.user.isAuthenticated);
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMobile();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");

  const isBilfen = window.location.hostname === "bilfen.madlen.io";
  const isIsik = window.location.hostname === "isik.madlen.io";
  const isItugv = window.location.hostname === "itugvo.madlen.io";
  const isAyseAbla = window.location.hostname === "ayseabla.madlen.io";
  const isIelev = window.location.hostname === "ielev.madlen.io";
  const isSev = window.location.hostname === "sev.madlen.io";
  const isTed = window.location.hostname === "ted.madlen.io";
  const isTedAnkara = window.location.hostname === "tedankara.madlen.io";
  const isNun = window.location.hostname === "nun.madlen.io";
  const isMba = window.location.hostname === "mba.madlen.io";
  const isMsu = window.location.hostname === "msu.madlen.io";
  const isMecOkullari = window.location.hostname === "mecokullari.madlen.io";
  const isYetev = window.location.hostname === "yetev.madlen.io";
  const isMef = window.location.hostname === "mef.madlen.io";
  const isCihangir = window.location.hostname === "cihangir.madlen.io";
  const isHisar = window.location.hostname === "hisar.madlen.io";

  const hideEmailLogin =
    isBilfen ||
    isIelev ||
    isAyseAbla ||
    isCihangir ||
    isHisar ||
    isMsu ||
    isMecOkullari;

  const [isEmailLogin, setIsEmailLogin] = useState(true);
  const [socialOnly, setSocialOnly] = useState(isYetev);

  // Force dark mode for this page
  useEffect(() => {
    document.documentElement.classList.add("dark");

    // Remove dark mode class when component unmounts
    return () => {
      document.documentElement.classList.remove("dark");
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      const targetPath = redirect || `/dashboard?${searchParams.toString()}`;
      navigate(targetPath);
    }
  }, [isAuthenticated, navigate, redirect, searchParams]);

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const auth = getAuth();
      const result = await signInWithPopup(auth, provider);
      const token = await result.user.getIdToken();
      const name = result.user.displayName || "";
      const surname = "";
      const avatar = result.user.photoURL || "";

      const response = await dispatch(
        loginUser({
          token,
          organizationId: 1,
          userType: "TEACHER",
          name,
          surname,
          language: i18n.language,
          avatar,
        }),
      );
      if (response.type === "fulfilled") {
        const targetPath = redirect || `/dashboard?${searchParams.toString()}`;
        navigate(targetPath);
      }
    } catch (error) {
      console.error("Google login failed:", error);
    }
  };

  const handleMicrosoftLogin = async () => {
    try {
      const provider = new OAuthProvider("microsoft.com");
      provider.setCustomParameters({
        prompt: "select_account",
      });
      const auth = getAuth();
      const result = await signInWithPopup(auth, provider);
      const token = await result.user.getIdToken();
      const name = result.user.displayName || "";
      const surname = "";
      const avatar = result.user.photoURL || "";

      const response = await dispatch(
        loginUser({
          token,
          organizationId: 1,
          userType: "TEACHER",
          name,
          surname,
          language: i18n.language,
          avatar,
        }),
      );
      if (response.type === "fulfilled") {
        const targetPath = redirect || `/dashboard?${searchParams.toString()}`;
        navigate(targetPath);
      }
    } catch (error) {
      console.error("Microsoft login failed:", error);
    }
  };

  const handleEmailLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      const auth = getAuth();
      const result = await signInWithEmailAndPassword(auth, email, password);
      const token = await result.user.getIdToken();
      const name = result.user.displayName || "";
      const surname = "";
      const avatar = result.user.photoURL || "";

      const response = await dispatch(
        loginUser({
          token,
          organizationId: 1,
          userType: "TEACHER",
          name,
          surname,
          language: i18n.language,
          avatar,
        }),
      );
      if (response.type === "fulfilled") {
        const targetPath = redirect || `/dashboard?${searchParams.toString()}`;
        navigate(targetPath);
      }
    } catch (error: any) {
      const errorMessage = error?.toString?.() || "";
      if (errorMessage.includes("auth/invalid-credential")) {
        setError("login.invalidCredentials");
      } else {
        setError("login.loginFailed");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const toggleEmailLogin = () => {
    setIsEmailLogin(!isEmailLogin);
    setError("");
  };

  return (
    <div className="h-screen bg-black flex overflow-hidden">
      {/* Left Side - Features Section */}
      <div className="hidden lg:flex lg:w-2/3 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 relative overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute inset-0">
          <div className="absolute top-0 -left-4 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
          <div className="absolute top-0 -right-4 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-2000"></div>
          <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse animation-delay-4000"></div>
        </div>

        <div className="relative flex flex-col justify-center p-8 w-full max-w-2xl mx-auto h-full">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <div className="flex items-center gap-0 mb-6">
              <img
                src={logo}
                alt="Madlen Logo"
                className="w-14 h-14 ml-[-20px]"
              />
              <Text
                variant="h1"
                size="xl"
                weight="semibold"
                className="text-white"
              >
                Swan
              </Text>
            </div>
            <Text
              variant="h2"
              size="xl"
              weight="medium"
              className="bg-gradient-to-r from-white to-purple-200 bg-clip-text text-transparent mb-3 leading-tight"
            >
              AI-Powered Teaching Platform
            </Text>
            <Text
              variant="p"
              size="sm"
              className="text-slate-300 leading-relaxed"
            >
              Empower your teaching with intelligent tools designed to enhance
              learning experiences and streamline your workflow.
            </Text>
          </motion.div>

          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-3 mb-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="bg-gradient-to-br from-purple-900/60 to-purple-800/40 backdrop-blur-sm border border-purple-700/50 rounded-xl p-4 hover:from-purple-800/70 hover:to-purple-700/50 hover:border-purple-600/60 hover:shadow-lg hover:shadow-purple-500/20 transition-all duration-300 group"
            >
              <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                <BrainIcon />
              </div>
              <Text
                variant="h3"
                size="sm"
                weight="medium"
                className="text-white mb-2"
              >
                AI Assistant
              </Text>
              <Text
                variant="p"
                size="xs"
                className="text-slate-300 leading-relaxed"
              >
                Get intelligent support for lesson planning, grading, and
                content creation.
              </Text>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="bg-gradient-to-br from-blue-900/60 to-blue-800/40 backdrop-blur-sm border border-blue-700/50 rounded-xl p-4 hover:from-blue-800/70 hover:to-blue-700/50 hover:border-blue-600/60 hover:shadow-lg hover:shadow-blue-500/20 transition-all duration-300 group"
            >
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                <BookOpenIcon />
              </div>
              <Text
                variant="h3"
                size="sm"
                weight="medium"
                className="text-white mb-2"
              >
                Lesson Planner
              </Text>
              <Text
                variant="p"
                size="xs"
                className="text-slate-300 leading-relaxed"
              >
                Create comprehensive lesson plans with interactive content and
                assessments.
              </Text>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="bg-gradient-to-br from-emerald-900/60 to-emerald-800/40 backdrop-blur-sm border border-emerald-700/50 rounded-xl p-4 hover:from-emerald-800/70 hover:to-emerald-700/50 hover:border-emerald-600/60 hover:shadow-lg hover:shadow-emerald-500/20 transition-all duration-300 group"
            >
              <div className="w-8 h-8 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                <UsersIcon />
              </div>
              <Text
                variant="h3"
                size="sm"
                weight="medium"
                className="text-white mb-2"
              >
                Student Management
              </Text>
              <Text
                variant="p"
                size="xs"
                className="text-slate-300 leading-relaxed"
              >
                Track progress, manage assignments, and foster student
                engagement.
              </Text>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="bg-gradient-to-br from-amber-900/60 to-orange-800/40 backdrop-blur-sm border border-amber-700/50 rounded-xl p-4 hover:from-amber-800/70 hover:to-orange-700/50 hover:border-amber-600/60 hover:shadow-lg hover:shadow-amber-500/20 transition-all duration-300 group"
            >
              <div className="w-8 h-8 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                <SparklesIcon />
              </div>
              <Text
                variant="h3"
                size="sm"
                weight="medium"
                className="text-white mb-2"
              >
                Smart Tools
              </Text>
              <Text
                variant="p"
                size="xs"
                className="text-slate-300 leading-relaxed"
              >
                Access a suite of intelligent tools for grading, analysis, and
                insights.
              </Text>
            </motion.div>
          </div>

          {/* Bottom Stats */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="flex items-center justify-between border-t border-gradient-to-r from-purple-500/30 via-blue-500/30 to-pink-500/30 pt-6 relative"
          >
            <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-purple-500/50 to-transparent"></div>
            <div className="text-center">
              <Text
                variant="h3"
                size="lg"
                weight="semibold"
                className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-1"
              >
                10K+
              </Text>
              <Text variant="p" size="xs" className="text-slate-400">
                Active Teachers
              </Text>
            </div>
            <div className="text-center">
              <Text
                variant="h3"
                size="lg"
                weight="semibold"
                className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-1"
              >
                1M+
              </Text>
              <Text variant="p" size="xs" className="text-slate-400">
                Students Reached
              </Text>
            </div>
            <div className="text-center">
              <Text
                variant="h3"
                size="lg"
                weight="semibold"
                className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent mb-1"
              >
                95%
              </Text>
              <Text variant="p" size="xs" className="text-slate-400">
                Satisfaction Rate
              </Text>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-6 bg-black">
        <div className="w-full max-w-sm">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="space-y-4"
          >
            {/* Organization Logos */}
            <div className="mb-4 text-center">
              {isIsik && (
                <img src={isik} alt="Isik Logo" className="h-10 mx-auto mb-3" />
              )}
              {isItugv && (
                <img
                  src={itugv}
                  alt="ITUGV Logo"
                  className="h-20 mx-auto mb-4"
                />
              )}
              {isSev && (
                <img src={sev} alt="SEV Logo" className="h-12 mx-auto mb-4" />
              )}
              {isTed && (
                <img src={ted} alt="TED Logo" className="h-14 mx-auto mb-4" />
              )}
              {isTedAnkara && (
                <img
                  src={tedAnkara}
                  alt="TED Ankara Logo"
                  className="h-20 mx-auto mb-4"
                />
              )}
              {isNun && (
                <img src={nun} alt="NUN Logo" className="h-12 mx-auto mb-4" />
              )}
              {isMba && (
                <img
                  src={mba}
                  alt="MBA Logo"
                  className="h-20 mx-auto mb-4 rounded-3xl"
                />
              )}
              {isMsu && (
                <img src={msu} alt="MSU Logo" className="h-20 mx-auto mb-4" />
              )}
              {isMecOkullari && (
                <img
                  src={mecOkullari}
                  alt="MEC Okullari Logo"
                  className="h-20 mx-auto mb-4"
                />
              )}
              {isYetev && (
                <img
                  src={yetev}
                  alt="YETEV Logo"
                  className="h-16 mx-auto mb-4 bg-white rounded-3xl p-3"
                />
              )}
              {isMef && (
                <img
                  src={mef}
                  alt="MEF Logo"
                  className="h-20 mx-auto mb-4 rounded-3xl"
                />
              )}
              {isCihangir && (
                <img
                  src={cihangir}
                  alt="Cihangir Logo"
                  className="h-20 mx-auto mb-4 bg-white rounded-3xl p-3"
                />
              )}
              {isHisar && (
                <img
                  src={hisar}
                  alt="Hisar Logo"
                  className="h-20 mx-auto mb-4"
                />
              )}
              {isAyseAbla && (
                <img
                  src={ayseabla}
                  alt="Ayse Abla Logo"
                  className="h-10 mx-auto mb-4 bg-white p-1 rounded-xl"
                />
              )}
              {isIelev && (
                <img
                  src={ielev}
                  alt="Ielev Logo"
                  className="h-20 mx-auto mb-4 bg-white p-2 rounded-3xl"
                />
              )}
              {isBilfen && (
                <img
                  src={bilfen}
                  alt="Bilfen Logo"
                  className="h-14 mx-auto mb-4 bg-white p-2 rounded-3xl"
                />
              )}
            </div>

            {/* Welcome Text */}
            <div className="mb-4">
              <Text
                variant="h1"
                size="xl"
                weight="semibold"
                className="text-white mb-1"
              >
                Login to your account
              </Text>
              <Text variant="p" size="xs" className="text-zinc-400">
                Enter your email below to login to your account
              </Text>
            </div>

            {/* Email Login Form */}
            {!socialOnly && (
              <AnimatePresence mode="wait">
                {!isEmailLogin ? (
                  <motion.div
                    key="email-button"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="space-y-4"
                  >
                    <Button
                      onClick={toggleEmailLogin}
                      bgColor="bg-white"
                      rounded="md"
                      textColor="text-black"
                      fullWidth
                      size="md"
                      className="h-10 hover:bg-zinc-100 transition-colors font-medium"
                    >
                      Continue with Email
                    </Button>
                  </motion.div>
                ) : (
                  <motion.form
                    key="email-form"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    onSubmit={handleEmailLogin}
                    className="space-y-3"
                  >
                    <div className="space-y-1">
                      <Text
                        variant="p"
                        size="xs"
                        className="text-white font-medium"
                      >
                        Email
                      </Text>
                      <Input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="test@example.com"
                        required
                        classNames={{
                          input:
                            "w-full h-10 px-3 rounded-md border border-zinc-700 bg-black text-white placeholder-zinc-500 focus:border-zinc-500 focus:ring-0 outline-none transition-colors",
                        }}
                      />
                    </div>

                    <div className="space-y-1">
                      <div className="flex items-center justify-between">
                        <Text
                          variant="p"
                          size="xs"
                          className="text-white font-medium"
                        >
                          Password
                        </Text>
                      </div>
                      <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••"
                        required
                        classNames={{
                          input:
                            "w-full h-10 px-3 rounded-md border border-zinc-700 bg-black text-white placeholder-zinc-500 focus:border-zinc-500 focus:ring-0 outline-none transition-colors",
                        }}
                      />
                    </div>

                    {error && (
                      <Text variant="p" size="sm" className="text-red-400">
                        {t(error)}
                      </Text>
                    )}

                    <Button
                      type="submit"
                      bgColor="bg-white"
                      rounded="md"
                      textColor="text-black"
                      fullWidth
                      size="md"
                      disabled={isLoading}
                      className="h-10 hover:bg-zinc-100 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isLoading ? (
                        <div className="flex items-center justify-center">
                          <svg
                            className="animate-spin -ml-1 mr-2 h-4 w-4"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Log In
                        </div>
                      ) : (
                        "Log In"
                      )}
                    </Button>
                  </motion.form>
                )}
              </AnimatePresence>
            )}

            {/* Social Login Section */}
            {!hideEmailLogin && (
              <div className="space-y-4">
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-zinc-800"></div>
                  </div>
                  <div className="relative flex justify-center text-xs uppercase">
                    <span className="bg-black px-2 text-zinc-400">
                      Or continue with
                    </span>
                  </div>
                </div>

                <div className="space-y-3">
                  <Button
                    onClick={handleGoogleLogin}
                    bgColor="bg-transparent"
                    rounded="md"
                    textColor="text-white"
                    size="md"
                    fullWidth
                    className="h-10 border border-zinc-700 hover:border-zinc-600 hover:bg-zinc-900 transition-colors"
                  >
                    <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24">
                      <path
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        fill="#4285F4"
                      />
                      <path
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        fill="#34A853"
                      />
                      <path
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                        fill="#FBBC05"
                      />
                      <path
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        fill="#EA4335"
                      />
                    </svg>
                    Login with Google
                  </Button>

                  <Button
                    onClick={handleMicrosoftLogin}
                    bgColor="bg-transparent"
                    rounded="md"
                    textColor="text-white"
                    fullWidth
                    size="md"
                    className="h-10 border border-zinc-700 hover:border-zinc-600 hover:bg-zinc-900 transition-colors"
                  >
                    <svg
                      className="w-4 h-4 mr-2"
                      viewBox="0 0 23 23"
                      fill="none"
                    >
                      <path fill="#F25022" d="M10.5 10.5H0.5V0.5h10v10z" />
                      <path fill="#00A4EF" d="M10.5 21.5H0.5V11.5h10v10z" />
                      <path fill="#7FBA00" d="M21.5 10.5H11.5V0.5h10v10z" />
                      <path fill="#FFB900" d="M21.5 21.5H11.5V11.5h10v10z" />
                    </svg>
                    Login with Microsoft
                  </Button>
                </div>
              </div>
            )}

            {/* Privacy Policy */}
            <div className="pt-0 text-center">
              <Text variant="p" size="xs" className="text-zinc-500">
                By continuing, you agree to our{" "}
                <Link
                  target="_blank"
                  className="text-zinc-400 hover:text-white transition-colors underline"
                  to="https://deploy.madlen.io/privacy.html"
                >
                  Privacy Policy
                </Link>
              </Text>
            </div>

            {/* Language Switcher */}
            <div className="flex justify-center gap-2 pt-2">
              <Button
                onClick={() => i18n.changeLanguage("en")}
                rounded="md"
                size="sm"
                bgColor={`${
                  (localStorage.getItem("i18nextLng") || "en") === "en"
                    ? "bg-zinc-800"
                    : "bg-transparent"
                }`}
                textColor="text-zinc-400"
                className="hover:text-white hover:bg-zinc-800 transition-colors border-0"
              >
                EN
              </Button>
              <Button
                onClick={() => i18n.changeLanguage("tr")}
                rounded="md"
                size="sm"
                bgColor={`${
                  (localStorage.getItem("i18nextLng") || "en") === "tr"
                    ? "bg-zinc-800"
                    : "bg-transparent"
                }`}
                textColor="text-zinc-400"
                className="hover:text-white hover:bg-zinc-800 transition-colors border-0"
              >
                TR
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default LoginView;
